import React, { Component } from 'react';
import { Input } from 'antd';

import _ from 'lodash';

class Search extends Component {
  componentDidMount = () => {
    // needs to prevent reload page on enter clicking
    if (typeof $ != 'undefined') {
      $('form').submit(function () {
        return false;
      });
    }
  };

  onSearchDebounced = _.debounce((value) => {
    this.props.onSearch(value);
  }, 800);

  render() {
    return (
      <Input.Search
        enterButton
        placeholder="Type here to search files"
        onSearch={this.props.onSearch}
        onChange={(e) => this.onSearchDebounced(e.target.value)}
        onSubmit={(event) => event.preventDefault()}
      />
    );
  }
}

export default Search;
